import { motion } from "framer-motion";

const IMAGES = {
  interior: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwbW9kZXJuJTIwaGFpciUyMHNhbG9uJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgzNTk1MDc4fDA&ixlib=rb-4.1.0&q=85",
  model1: "https://images.unsplash.com/photo-1523264766116-1e09b3145b84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAzNDR8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwZmFzaGlvbiUyMGhhaXIlMjBtb2RlbHxlbnwwfHx8fDE3ODM1OTUwNzh8MA&ixlib=rb-4.1.0&q=85",
  model2: "https://images.unsplash.com/photo-1633381521050-26bb467d9d5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAzNDR8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwZmFzaGlvbiUyMGhhaXIlMjBtb2RlbHxlbnwwfHx8fDE3ODM1OTUwNzh8MA&ixlib=rb-4.1.0&q=85",
  training1: "https://images.unsplash.com/photo-1734111719430-fe4a3973f8af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxoYWlyJTIwc3R5bGlzdCUyMHRyYWluaW5nJTIwYWNhZGVteXxlbnwwfHx8fDE3ODM1OTUwNzh8MA&ixlib=rb-4.1.0&q=85",
};

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6 },
};

export const ServicesSection = ({ services }) => {
  const categories = [...new Set(services.map((s) => s.category))].filter((c) => c !== "Academy" && c !== "Packages");
  return (
    <section id="services" className="py-24 lg:py-32 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div {...fadeUp} className="mb-16">
          <p className="text-[#C5A059] uppercase tracking-[0.3em] text-xs font-semibold mb-4">Our Menu</p>
          <h2 className="font-serif-brand text-4xl sm:text-5xl text-[#1C1C1C] font-medium tracking-tight">Services &amp; Pricing</h2>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-12" data-testid="services-list">
          {categories.map((cat) => (
            <motion.div key={cat} {...fadeUp}>
              <h3 className="text-sm uppercase tracking-[0.25em] text-[#0A3F2F] font-bold border-b border-[#C5A059]/40 pb-3 mb-6">{cat}</h3>
              <ul className="space-y-6">
                {services.filter((s) => s.category === cat).map((s) => (
                  <li key={s.id} data-testid={`service-item-${s.id}`}>
                    <div className="flex items-baseline justify-between gap-4">
                      <span className="font-serif-brand text-xl text-[#1C1C1C] font-semibold">{s.name}</span>
                      <span className="text-[#0A3F2F] font-bold text-sm whitespace-nowrap">₹{s.price.toLocaleString("en-IN")}</span>
                    </div>
                    <p className="text-[#5C6A63] text-sm mt-1 font-light">{s.description}</p>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const GallerySection = () => (
  <section id="gallery" className="py-24 lg:py-32 bg-[#0A3F2F]">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <motion.div {...fadeUp} className="mb-16">
        <p className="text-[#C5A059] uppercase tracking-[0.3em] text-xs font-semibold mb-4">Our Work</p>
        <h2 className="font-serif-brand text-4xl sm:text-5xl text-[#FAFAF8] font-medium tracking-tight">The Gallery</h2>
      </motion.div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[220px]" data-testid="gallery-grid">
        <motion.img {...fadeUp} src={IMAGES.model1} alt="Elegant hair styling result" className="w-full h-full object-cover col-span-2 row-span-2 rounded-md" />
        <motion.img {...fadeUp} src={IMAGES.interior} alt="Salon interior" className="w-full h-full object-cover rounded-md" />
        <motion.img {...fadeUp} src={IMAGES.training1} alt="Stylist at work" className="w-full h-full object-cover row-span-2 rounded-md" />
        <motion.img {...fadeUp} src={IMAGES.model2} alt="Fashion hair model" className="w-full h-full object-cover rounded-md" />
      </div>
    </div>
  </section>
);
